"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import Link from "next/link";
import "@/app/auto-verkaufen/AutoVerkaufen.css";
import "@/common/Common.css";

import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";
import { TopSectionAutoVerkaufen } from "@/app/auto-verkaufen/sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";
import höchstenPreis from "@/assets/auto-verkaufen/wir-kaufen-dein-auto-verkauf.avif";
import vonZuhauseAus from "@/assets/auto-verkaufen/wir-kaufen-dein-auto-hoechstpreis.avif";
import VerkaufenStandort from "@/assets/auto-bewerten/verkaufen-standort.webp";
import { fragenMotorschaden } from "./data";
import { HäufigeFragen } from "@/common/HäufigeFragen";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";

const Ratgeber = dynamic(() => import("@/components/Ratgeber/Ratgeber"), {
  ssr: false,
});

const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function Motorschaden() {
  const [step, setStep] = useState(1);

  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionAutoVerkaufen
        title={<>Auto mit Motorschaden verkaufen – so funktioniert’s</>}
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*
            <br className="desktop" />
            Verkaufe dein Auto mit Motorschaden und erhalte mehr Geld.
          </>
        }
        customNav="Kaputtes Auto"
        customNavLink="/kaputtes-auto-verkaufen"
        linkname="Motorschaden Auto Verkaufen"
        link="/kaputtes-auto-verkaufen/motorschaden-auto-verkaufen"
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/kaputtes-auto-verkaufen/motorschaden-auto-verkaufen"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="PKW mit Motorschaden"
              leftText={
                <>
                  <p>
                    Ein Motorschaden ist für viele Autofahrer ein Schock.
                    Plötzlich steht das Fahrzeug still, und eine Reparatur kann
                    mehrere tausend Euro kosten. Oft übersteigt sie den
                    Restwert des Autos. In dieser Situation fragen sich viele:
                    Lohnt sich eine Reparatur überhaupt noch oder sollte ich
                    mein Auto mit Motorschaden verkaufen? Genau hier bietet
                    Autoeinfachlos eine Lösung. Mit unserem großen Netzwerk aus
                    über 5.000 geprüften Händlern kannst du dein defektes
                    Fahrzeug schnell, unkompliziert und zu einem fairen Preis
                    verkaufen, ohne versteckte Kosten und ohne lange
                    Wartezeiten.
                  </p>
                </>
              }
              rightFirstTitle="Motorschaden - was bedeutet das für den Autoverkauf?"
              rightFirstText={
                <>
                  <p>
                    Ein Motorschaden liegt vor, wenn zentrale Bauteile wie
                    Kolben, Zylinder oder die Kurbelwelle beschädigt sind.
                    Häufige Ursachen sind:
                  </p>
                  <ul className="custom-unordered-list">
                    <li>Überhitzung oder Ölmangel</li>
                    <li>Kolbenfresser oder Lagerschaden</li>
                    <li>Zahnriemen- oder Steuerkettenriss</li>
                    <li>Schäden nach einem Unfall</li>
                  </ul>

                  <p>
                    Die Folgen sind meist gravierend. Motorschaden
                    Reparaturkosten liegen schnell zwischen 3.000 und 8.000
                    Euro, bei älteren Fahrzeugen oft mehr als das Auto noch
                    wert ist. Für viele Halter bedeutet das einen erheblichen
                    Wertverlust. Ein Verkauf ist daher meist die wirtschaftlich
                    sinnvollste Entscheidung.
                  </p>
                </>
              }
              rightSecondTitle="Warum ein Auto mit Motorschaden verkaufen statt reparieren?"
              rightSecondText={
                <>
                  <p>
                    Eine Reparatur klingt auf den ersten Blick nach einer
                    Option, doch die Realität sieht oft anders aus:
                  </p>
                  <ul className="custom-unordered-list secondary">
                    <li>Hohe und schwer kalkulierbare Reparaturkosten</li>
                    <li>Längere Ausfallzeiten des Autos</li>
                    <li>Risiko von Folgeschäden</li>
                  </ul>

                  <p>
                    Wenn du dein Auto mit Motorschaden verkaufst, hast du klare
                    Vorteile:
                  </p>
                  <ul className="custom-unordered-list secondary">
                    <li>
                      Sofortiger Verkaufserlös statt unkalkulierbarer
                      Werkstattkosten
                    </li>
                    <li>
                      Schneller und transparenter Prozess ohne lange
                      Wartezeiten
                    </li>
                    <li>
                      Kein Risiko, dass nach der Reparatur weitere Probleme
                      auftreten
                    </li>
                  </ul>

                  <p>
                    Gerade bei älteren Fahrzeugen ist ein Verkauf oft die
                    deutlich bessere Lösung.
                  </p>
                </>
              }
            />

            <div className="Banner-sections">
              <BildTextInfo
                image={höchstenPreis}
                h2
                isBig
                fontSize="36px"
                title="Wer kauft Autos mit Motorschaden?"
                alt="Auto mit Motorschaden an Händler verkaufen"
                text={
                  <>
                    <p>
                      Viele private Käufer schrecken vor einem defekten Auto
                      zurück. Die Suche nach einem passenden Käufer kann Monate
                      dauern und am Ende trotzdem scheitern.
                    </p>
                    <p>
                      Ein professionelles Händlernetzwerk ist hier die bessere
                      Wahl. Bei Autoeinfachlos arbeitest du mit über 5.000
                      registrierten Händlern, die auch Fahrzeuge mit
                      Motorschaden ankaufen. Durch die große Konkurrenz
                      entstehen faire Preise, ohne dass du selbst verhandeln
                      musst.
                    </p>
                  </>
                }
              />

              <BildTextInfo
                image={vonZuhauseAus}
                revert
                h2
                isBig
                fontSize="36px"
                title="Was ist mein Auto mit Motorschaden noch wert?"
                alt="Auto mit Motorschaden bewerten"
                text={
                  <>
                    <p>
                      Der Auto Motorschaden Wert hängt von mehreren Faktoren ab:
                    </p>
                    <ul className="custom-unordered-list">
                      <li>Marke und Modell</li>
                      <li>Alter des Fahrzeugs</li>
                      <li>Kilometerstand</li>
                      <li>Ausstattungsmerkmale</li>
                      <li>Umfang des Schadens</li>
                    </ul>

                    <p>
                      Selbst bei schweren Defekten kann dein Fahrzeug noch einen
                      attraktiven Restwert haben. Über unsere kostenlose
                      Online-Bewertung erfährst du sofort, welchen Preis du
                      erwarten kannst. Jetzt Auto bewerten.
                    </p>

                    <h3>
                      Ablauf: So verkaufst Du Dein Auto mit Motorschaden über
                      Autoeinfachlos
                    </h3>
                    <p>Der Verkauf ist bei uns einfach und transparent:</p>
                    <ol className="custom-ordered-list">
                      <li>
                        <strong>Fahrzeug bewerten</strong>
                        <br />
                        Gib die Daten deines Autos online ein und erhalte
                        kostenlos eine erste Einschätzung.
                      </li>
                      <li>
                        <strong>Händler konkurrieren lassen</strong>
                        <br />
                        Dein Auto wird in einer 24-Stunden-Online-Auktion
                        präsentiert. Händler bieten auf dein Fahrzeug, sodass du
                        den bestmöglichen Preis erhältst.
                      </li>
                      <li>
                        <strong>Abholung & sichere Zahlung</strong>
                        <br />
                        Der Käufer holt dein Auto direkt bei dir ab, die
                        Bezahlung erfolgt sicher und unkompliziert.
                      </li>
                    </ol>

                    <p>
                      So sparst du Zeit, Nerven und unnötige Kosten und kannst
                      dein defektes Auto schnell zu Geld machen.
                    </p>
                  </>
                }
              />
            </div>

            <HäufigeFragen
              title="Häufige Fragen rund um den Verkauf bei Motorschaden"
              fragen={fragenMotorschaden}
              image={FAQImage}
              removePaddingBottom
            />

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema Auto mit Motorschaden verkaufen"
                kaputtesAuto
                unfallAuto
                autoExport
                autoBewerten
                autoVerkaufen
                listenpreisBerechnen
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={VerkaufenStandort}
                h2
                isBig
                fontSize="36px"
                title="Jetzt Auto mit Motorschaden verkaufen"
                alt="Jetzt Auto mit Motorschaden verkaufen"
                text={
                  <>
                    <p>
                      Ein Motorschaden muss nicht das Ende bedeuten. Statt hohe
                      Motorschaden Reparaturkosten zu tragen, kannst du dein
                      Auto unkompliziert und seriös verkaufen. Autoeinfachlos
                      bietet dir mit 5.000 Händlern die besten Chancen auf
                      einen fairen Preis.
                    </p>

                    <p>
                      Starte jetzt deine kostenlose Fahrzeugbewertung und finde
                      heraus, was dein Auto noch wert ist:{" "}
                      <Link className="link" href="/auto-bewerten">
                        Auto Bewerten
                      </Link>
                      .
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-bewerten"
            title="Jetzt Auto mit Motorschaden bewerten"
            h2
          />
        </div>
      )}
    </div>
  );
}

export default Motorschaden;
